import {ApiService} from "../index";
import {APIConfig} from "../../../constants";


const GetInvoiceDetails = (invoiceId: string) => {
    return ApiService[APIConfig.GET_INVOICE_DETAILS.METHOD](APIConfig.GET_INVOICE_DETAILS.URL(invoiceId));
}

const GetReceiptDetails = (receiptId: string) => {
    return ApiService[APIConfig.GET_RECEIPT_DETAILS.METHOD](APIConfig.GET_RECEIPT_DETAILS.URL(receiptId));
}

const VerifyCoupon = (payload:any) =>{
    return ApiService[APIConfig.VERIFY_COUPON.METHOD](APIConfig.VERIFY_COUPON.URL, payload);
}

const InvoicePayment = (invoiceId: string, payload:any) =>{
    return ApiService[APIConfig.INVOICE_PAYMENT.METHOD](APIConfig.INVOICE_PAYMENT.URL(invoiceId), payload);
}
const PendingPaymentList = () =>{
    return ApiService[APIConfig.GET_PENDING_PAYMENT_LIST.METHOD](APIConfig.GET_PENDING_PAYMENT_LIST.URL);
}

export const TransactionService = {
    GetInvoiceDetails,
    GetReceiptDetails,
    VerifyCoupon,
    InvoicePayment,
    PendingPaymentList
}
